export const FIND_ASSIGNABLE_ASSET_ROUTINES = `
  query FindAssignableAssetRoutines($filter: FindAssignableAssetRoutinesFilter!, $page: PageRequest) {
    routine {
      findAssignableAssetRoutines(filter: $filter, page: $page) {
        count
        limit
        offset
        items {
          id
          name
          type
          config
          order
          deactivated
        }
      }
    }
  }
`;
